import { createEnum } from "@redotech/zod-util/zod-enum";

/**
 * How an order editing hold is applied to a Shopify order: either a native
 * fulfillment hold or an order tag. Kept in a dependency-free leaf module so
 * both `flat-team-settings` and the order editing settings slice can use it.
 */
export enum HoldStatusStrategy {
  SHOPIFY_FULFILLMENT_HOLD = "shopify_fulfillment_hold",
  SHOPIFY_ORDER_TAG = "shopify_order_tag",
}

export const HoldStatusStrategyZod = createEnum([
  HoldStatusStrategy.SHOPIFY_FULFILLMENT_HOLD,
  HoldStatusStrategy.SHOPIFY_ORDER_TAG,
]);

export function isAutoRevertSupportedHoldStrategy(
  holdStatusStrategy: HoldStatusStrategy | undefined,
): boolean {
  return (
    (holdStatusStrategy ?? HoldStatusStrategy.SHOPIFY_FULFILLMENT_HOLD) ===
    HoldStatusStrategy.SHOPIFY_FULFILLMENT_HOLD
  );
}
